// import { logout } from "@/lib/api_controller";

export default function Logo({ onClick = undefined }) {
  return (
    <picture onClick={onClick} className="cursor-pointer">
      <source
        srcSet="
        /assets/branding/taalia-wordmark-no-margin-120w.webp 1x,
        /assets/branding/taalia-wordmark-no-margin-120w@2x.webp 2x,
        /assets/branding/taalia-wordmark-no-margin-120w@3x.webp 3x,
        /assets/branding/taalia-wordmark-no-margin-120w@4x.webp 4x"
        type="image/webp"
      />
      <img
        src="/assets/branding/taalia-wordmark-no-margin-120w.png"
        srcSet="
        /assets/branding/taalia-wordmark-no-margin-120w.png 1x,
        /assets/branding/taalia-wordmark-no-margin-120w@2x.png 2x,
        /assets/branding/taalia-wordmark-no-margin-120w@3x.png 3x,
        /assets/branding/taalia-wordmark-no-margin-120w@4x.png 4x"
        alt="Taalia Logo"
        className="mx-auto h-[24px] w-auto"
        fetchPriority="high"
        decoding="async"
        loading="eager"
      />
    </picture>
  );
}
